<div
  class="px-2 sm:px-4 font-app-regular max-w-full"
  *ngIf="policyChangeLog; else errorTemplate">
  <!-- All Policies-->
  <section
    *ngIf="hasValues(multiContractRecords)"
    class="mb-6">
    <h1 class="text-base md:text-xl font-app-bold mb-4">
      {{ "additionalClausePolicyChangesDialog.allPoliciesModifications" | translate }}
    </h1>
    <ng-container *ngFor="let changesGroup of multiContractRecords | keyvalue">
      <h2 class="text-base sm:text-lg font-app-bold text-gray-700 mb-3 mt-4">
        {{ getTranslatedCategory(changesGroup.key) }}
      </h2>
      <ng-container
        [ngTemplateOutlet]="changeDisplay"
        [ngTemplateOutletContext]="{ data: changesGroup }">
      </ng-container>
    </ng-container>
  </section>

  <!-- One policy-->
  <section
    *ngIf="hasValues(monoContractRecords)"
    class="mb-6">
    <h1 class="text-base md:text-xl font-app-bold mb-4">
      {{ "additionalClausePolicyChangesDialog.specificPolicyModifications" | translate: { reference: reference } }}
    </h1>
    <ng-container *ngFor="let changesGroup of monoContractRecords | keyvalue">
      <h2 class="text-base sm:text-lg font-app-bold text-gray-700 mb-3 mt-4">
        {{ getTranslatedCategory(changesGroup.key) }}
      </h2>
      <!-- Changes but school insurance -->
      <ng-container
        *ngIf="getGenericActivationFields(changesGroup.value) as genericInsuranceEntries"
        [ngTemplateOutlet]="changeDisplay"
        [ngTemplateOutletContext]="{ data: { key: changesGroup.key, value: genericInsuranceEntries } }">
      </ng-container>
      <!-- School insurance -->
      <ng-container
        *ngIf="getSchoolInsuranceActivationFields(changesGroup.value) as schoolInsuranceEntry"
        [ngTemplateOutlet]="changeDisplay"
        [ngTemplateOutletContext]="{ data: { key: changesGroup.key, value: [schoolInsuranceEntry] } }">
      </ng-container>
      <!-- School insurance children -->
      <ng-container
        *ngFor="
          let childGroup of groupChildrenByIndex(getSchoolInsuranceChildActivationFields(changesGroup.value));
          let childIndex = index
        ">
        <!-- Child header -->
        <div class="mt-4 mb-2 bg-gray-50 p-2 rounded-lg">
          <h3 class="font-app-bold mb-2">Enfant {{ childIndex + 1 }} :</h3>
          <div class="ml-4">
            <!-- Display child fields -->
            <ng-container
              [ngTemplateOutlet]="changeDisplay"
              [ngTemplateOutletContext]="{ data: { key: changesGroup.key, value: childGroup } }">
            </ng-container>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </section>

  <ng-template
    #changeDisplay
    let-data="data">
    <div
      *ngFor="let change of data.value"
      class="flex flex-col sm:flex-row gap-2 mt-2 mb-3 justify-center items-center">
      <span class="valueDiff valueDiffLabel w-full sm:w-1/3 font-app-regular text-sm md:text-base text-dark">
        {{ getLabel(change.field.label) }}
      </span>
      <span
        class="valueDiff valueDiffBefore w-full sm:w-1/3 text-sm md:text-base px-2 py-1 bg-gray-100 rounded-xl flex justify-center items-center"
        >{{ getValue(data.key, change.field.name, change.oldValue) }}</span
      >
      <span
        class="valueDiff valueDiffAfter w-full sm:w-1/3 text-sm md:text-base px-2 py-1 bg-primary_text text-white rounded-xl flex justify-center items-center"
        >{{ getValue(data.key, change.field.name, change.newValue) }}</span
      >
    </div>
  </ng-template>

  <!-- User choice-->
  <section
    *ngIf="hasValues(userChoiceRecords)"
    class="mb-6">
    <h1 class="text-base md:text-xl font-app-bold mb-4">
      {{ "additionalClausePolicyChangesDialog.specificPolicyModifications" | translate: { reference: reference } }}
    </h1>
    <ng-container *ngFor="let changesGroup of userChoiceRecords | keyvalue">
      <h2 class="text-base md:text-lg font-app-bold text-gray-700 mb-3 mt-4">
        {{ getTranslatedCategory(changesGroup.key) }}
      </h2>
      <div
        *ngFor="let change of changesGroup.value"
        class="flex flex-col sm:flex-row gap-2 mt-2 mb-3">
        <span class="valueDiff valueDiffLabel w-full sm:w-1/3 font-app-regular text-sm md:text-base text-dark">{{
          getLabel(change.field.label)
        }}</span>
        <span class="valueDiff valueDiffBefore w-full sm:w-1/3 text-sm md:text-base px-2 py-1 bg-gray-100 rounded-xl">{{
          getValue(changesGroup.key, change.field.name, change.oldValue)
        }}</span>
        <span
          class="valueDiff valueDiffAfter w-full sm:w-1/3 text-sm md:text-base px-2 py-1 bg-primary_text text-white rounded-xl"
          >{{ getValue(changesGroup.key, change.field.name, change.newValue) }}</span
        >
      </div>
    </ng-container>
  </section>

  <!-- Impact -->
  <section
    *ngIf="policyChangeLog.documents && policyChangeLog.documents.length > 0"
    class="mb-6">
    <h1 class="text-base md:text-xl font-app-bold mb-4">
      {{ "additionalClausePolicyChangesDialog.impactedPolicies.title" | translate }}
    </h1>
    <div class="overflow-x-auto">
      <p-table
        class="policyImpacts"
        [value]="policyChangeLog.contracts"
        styleClass="w-full min-w-max">
        <ng-template pTemplate="header">
          <tr>
            <th
              scope="col"
              class="text-sm md:text-base">
              {{ "additionalClausePolicyChangesDialog.impactedPolicies.columns.product" | translate }}
            </th>
            <th
              scope="col"
              class="text-sm md:text-base">
              {{ "additionalClausePolicyChangesDialog.impactedPolicies.columns.reference" | translate }}
            </th>
            <th
              scope="col"
              class="text-sm md:text-base">
              {{ "additionalClausePolicyChangesDialog.impactedPolicies.columns.formerCost" | translate }}
            </th>
            <th
              scope="col"
              class="text-sm md:text-base">
              {{ "additionalClausePolicyChangesDialog.impactedPolicies.columns.newCost" | translate }}
            </th>
          </tr>
        </ng-template>
        <ng-template
          pTemplate="body"
          let-policyImpact>
          <tr>
            <td class="text-sm md:text-base">{{ policyImpact.productName }}</td>
            <td class="text-sm md:text-base">{{ policyImpact.reference }}</td>
            <td class="text-sm md:text-base">
              {{ policyImpact.oldMonthlyTTC | currency: "€" : "symbol" : "1.2-2" : "fr"
              }}{{ "additionalClausePolicyChangesDialog.pricePerMonth" | translate }}
            </td>
            <td class="font-bold !text-primary text-sm md:text-base">
              {{ policyImpact.newMonthlyTTC | currency: "€" : "symbol" : "1.2-2" : "fr"
              }}{{ policyImpact.newMonthlyTTC && "additionalClausePolicyChangesDialog.pricePerMonth" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="mt-6">
      <h2 class="text-base md:text-lg font-app-bold text-gray-700 mb-3">
        {{ "additionalClausePolicyChangesDialog.documentsToSign" | translate }}
      </h2>
      <ul class="documentToSignList flex flex-col sm:flex-row flex-wrap gap-2 mt-3">
        <li
          *ngFor="let document of policyChangeLog.documents"
          class="basis-full sm:basis-2/5 grow sm:max-w-[50%] text-sm mb-2">
          {{ document }}
        </li>
      </ul>
    </div>
  </section>

  <!-- Signature -->
  <section
    *ngIf="displaySignaturePhone && policyChangeLog.documents.length > 0"
    class="mb-6">
    <h1 class="text-base md:text-xl font-app-bold mb-4">
      {{ "additionalClausePolicyChangesDialog.signature" | translate: { reference: reference } }}
    </h1>
    <ng-container>
      <div class="flex flex-col sm:flex-row gap-2 mt-4 mb-4">
        <span class="w-full sm:w-1/3 font-app-regular text-sm md:text-base text-dark">{{
          "additionalClausePolicyChangesDialog.phoneMandatory" | translate
        }}</span>
        <div class="w-full sm:w-2/3 flex sm:flex-row items-start sm:items-center mb-2">
          <p-dropdown
            [options]="phonePrefixes"
            [(ngModel)]="phonePrefix"
            optionLabel="prefix"
            class="w-full sm:w-1/3 mb-2 sm:mb-0"
            (ngModelChange)="onPhonePrefixChange($event)">
            <ng-template
              let-phonePrefixes
              pTemplate="item">
              <div class="flex justify-between items-center font-bold">
                <div class="mr-4">{{ phonePrefixes.region }}</div>
                <div>{{ phonePrefixes.prefix }}</div>
              </div>
            </ng-template>
          </p-dropdown>
          <span class="p-float-label w-full sm:w-2/3 mt-2 sm:mt-0 ml-0 sm:ml-2">
            <p-inputMask
              type="text"
              [(ngModel)]="phoneNumber"
              [placeholder]="phonePattern"
              pattern="[0-9]*"
              pKeyFilter="int"
              [autoClear]="false"
              [unmask]="true"
              [mask]="phoneMask"
              class="w-full"
              (ngModelChange)="onPhoneNumberChange()">
            </p-inputMask>
          </span>
        </div>
      </div>
      <div class="flex flex-col gap-2 mt-4 pl-0">
        <span class="flex items-center gap-2">
          <p-checkbox
            [(ngModel)]="phoneSignatureCheckbox"
            [binary]="true"
            (ngModelChange)="onPhoneSignatureCheckboxChange($event)"></p-checkbox>
          <p class="text-sm font-medium">{{ "additionalClausePolicyChangesDialog.acceptGestion" | translate }}</p>
        </span>
      </div>
    </ng-container>
  </section>

  <aside
    *ngIf="policyChangeLog.signatureLimitDate && policyChangeLog.documents.length > 0"
    class="flex sm:flex-row items-start sm:items-center gap-3 sm:gap-5 border-primary border-solid border-[2px] rounded-2xl px-4 sm:px-5 py-3 mt-5">
    <i class="pi pi-exclamation-triangle text-xl sm:text-3xl"></i>
    <p class="text-sm">
      {{
        "additionalClausePolicyChangesDialog.documentsToSignDateWarning"
          | translate: { date: policyChangeLog.signatureLimitDate | date: "dd/MM/yyyy" }
      }}
    </p>
  </aside>
</div>

<ng-template #errorTemplate>
  <div class="p-4 bg-red-100 text-red-700 rounded-lg">Erreur lors du chargement des modifications du contrat.</div>
</ng-template>
